import { useContext, Dispatch } from "react";

import { StateContext } from "config/state";

export const initialState = {
  coursesFilters: {
    pagination: { rowsPerPage: 10 },
    orderBy: ["createdAt,DESC"]
  }
};

type State = typeof initialState;

export enum actionTypes {
  SET_COURSES_FILTERS = "setCoursesFilters",
  RESET_COURSES_FILTERS = "resetCoursesFilters"
}

const reducer = (
  state = initialState,
  action: { type: actionTypes; payload?: any }
) => {
  switch (action.type) {
    case actionTypes.SET_COURSES_FILTERS: {
      return {
        ...state,
        coursesFilters: action.payload
      };
    }
    case actionTypes.RESET_COURSES_FILTERS: {
      return {
        ...state,
        coursesFilters: initialState.coursesFilters
      };
    }
    default:
      return state;
  }
};

export const useModuleState = (): [
  State,
  Dispatch<{ type: actionTypes; payload?: any }>
] => {
  const [state, dispatch] = useContext(StateContext);
  return [state.courses, dispatch];
};

export default reducer;
